import React, {forwardRef, useMemo} from 'react'
import { ModulesArea } from '../../styles/timeline/gridAreas'
import {css} from '../../styles/stitches.config'
import { getNowInTz } from '../../utils/timezones'

// 1..24, but effectively shifted down by an extra row
const hours = Array.from({ length: 24 }, (_, i) => i + 1)

function formatHour(hour: number): string {
  if (hour === 24) return '12 AM'
  if (hour === 12) return '12 PM'
  if (hour > 12) return `${hour - 12} PM`
  return `${hour} AM`
}

interface HourRowsProps {
  size?: 'lg' | 'sm'
  activeTz?: string
}

const hourLabelStyle = css({ color: '$neutral8', fontSize: '$sm' }) // No `()`
const highlightedHourStyle = css({
  color: '$blue11',
  fontWeight: 'bold'
})

export const HourRows = forwardRef<HTMLDivElement, HourRowsProps>(
  ({size = 'lg', activeTz}: HourRowsProps, ref) => {
  const currentHour = useMemo(() => {
    if (activeTz) return getNowInTz(activeTz).hours
    return new Date().getHours()
  }, [activeTz])
  return (
    <ModulesArea size={size} ref={ref}>
      {/* First empty row (no label, no line) */}
      <div style={{ height: '100%' }} />

      {hours.map((hour) => (
        <div
          key={hour}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'flex-start', // Align text at the top (border)
            height: '100%',
          }}
        >
          {/* Hour label positioned on the border */}
          <span
            className={`${hourLabelStyle()} ${hour === currentHour ? highlightedHourStyle() : ''}`}
            style={{
              marginLeft: '0.5rem',
              zIndex: 1,
              transform: 'translateY(-50%)', // Moves text up to align with the border
              position: 'absolute',
              top: 0,
            }}
          >
            {formatHour(hour)}
          </span>

          {/* Draw the line exactly on the row border */}
          <div
            style={{
              position: 'absolute',
              top: 0, // Line on the top border
              left: '4rem',
              right: 0,
              height: '1px',
              backgroundColor: '#ccc',
            }}
          />

                    {/* <div
            style={{
              position: 'absolute',
              top: '50%',     // 50% down from the top of this hour cell
              left: '3rem',
              right: 0,
              height: '1px',  // 1px is about as thin as you can reliably get.
              backgroundColor: '#ddd',
              zIndex: 0,
            }}
          /> */}
        </div>

        

      ))}

      
    </ModulesArea>
  )
}
)
HourRows.displayName = 'HourRows'
